import * as React from "react";

const ZionPage : React.FC = () => {
    return (
        <React.Fragment>
            <div className={"zion"}>
            <div>
                <img src={"/images/header_zion.png"} className={"header"} alt={"宮岡クリニック ジオン注 - 通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
                <div className={"index-section"}>
                    <div className={"index"}>目次</div>
                    <ul>
                        <li><a href={"#zion"}>ジオン注とは？</a></li>
                        <li><a href={"#zion1"}>1.痔核（いぼ痔）とはどんな病気でしょうか？</a></li>
                        <li><a href={"#zion2"}>2.ジオン注による治療法とはどんなものでしょうか？</a></li>
                        <li><a href={"#zion3"}>3.ジオン注とはどんな薬でしょうか？</a></li>
                        <li><a href={"#zion4"}>4.どのようにジオン注を投与するのでしょうか？</a></li>
                        <li><a href={"#zion5"}>5.ジオン注を投与するとどうなるのでしょうか？</a></li>
                        <li><a href={"#zion6"}>6.ジオン注の投与後の経過は？</a>
                            <ul>
                                <li><a href={"#zion6-1"}>排便はいつから？</a></li>
                                <li><a href={"#zion6-2"}>仕事復帰は？</a></li>
                            </ul>
                        </li>
                        <li><a href={"#zion7"}>7.日常生活で注意すべきことはなんでしょうか？</a></li>
                    </ul>
                </div>
            <h1 id={"zion"}>ジオン注とは？</h1>
            <p>
                「ジオン注」とは、脱出を伴う内痔核(排便時に出てくる、あるいは普段から出たままになっているようないぼ痔)に対して、注射による治療を可能にしたものです。
            </p>
            <h1 id={"zion1"}>1.痔核（いぼ痔）とはどんな病気でしょうか？</h1>
            <p>
                肛門周辺の粘膜の下には、血管が集まって肛門を閉じる働きをするクッションのような部分があります。肛門への負担が重くなると、クッションを支える組織（支持組織）が引き伸ばされ、クッション部分が大きくなり、出血したり肛門の外に出たりするようになります。これが痔核（いぼ痔）です。
            </p>
            <div>
                <img src={"/images/zion1-1.gif"}/>
            </div>
            <p>
                痔核には、直腸側にできる内痔核と、肛門側にできる外痔核があります。また、内痔核が大きくなって脱出するようになると肛門側の痔核、つまり外痔核を伴って内外痔核という状態になることもあります。
            </p>
            <h1 id={"zion2"}>2.ジオン注による治療法とはどんなものでしょうか？</h1>
            <p>
                「脱出を伴う内痔核」にジオン注を投与して痔に流れ込む血液の量を減らし、痔を硬くして粘膜に癒着・固定させる治療法です。
            </p>
            <p>
                痔核を切り取る手術と違って、痔核の痛みを感じない部分に注射するので「傷口から出血する」「傷口が痛む」ということはなく、入院期間の短縮も期待できます。
            </p>
            <h1 id={"zion3"}>3.ジオン注とはどんな薬でしょうか？</h1>
            <p>
                ジオン注の有効成分は硫酸アルミニウムカリウムとタンニン酸というものです。
            </p>
            <ul>
                <li>硫酸アルミニウムカリウム・・・出血症状や脱出症状を改善する。</li>
                <li>タンニン酸・・・硫酸アルミニウムカリウムの働きを調節する。</li>
            </ul>
            <h1 id={"zion4"}>4.どのようにジオン注を投与するのでしょうか？</h1>
            <p>
                ジオン注を投与する前に肛門周囲への麻酔か、下半身だけに効く麻酔を行い肛門周囲の筋肉を暖め注射しやすくします。
            </p>
            <p>
                ジオン注はひとつの痔核に対して図のように4か所に分割して投与します。<br/>
                これは痔核に薬液を十分に浸透させるための方法で、四段階注射法といいます。<br/>
                複数の痔核がある場合には、それぞれに投与します。投与後しばらく点滴を続け、麻酔の影響がなくなるまで安静にする必要があります。<br/>
            </p>
            <div>
                <img src={"/images/zion4-1.gif"}/>
            </div>
            <h1 id={"zion5"}>5.ジオン注を投与するとどうなるのでしょうか？</h1>
            <table className={"no-border"}>
                <tbody>
                    <tr>
                        <td>
                            <p>
                            投与後の早い時期に痔核へ流れ込む血液の量が減り出血が止まります。<br/>
                            脱出の程度も軽くなります。
                            </p>
                        </td>
                        <td>
                            <img src={"/images/zion5-1.gif"}/>
                        </td>
                    </tr>
                    <tr>
                        <td className={"center"}>
                            <img src={"/images/yazirusi.gif"}/>
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>
                            <p>
                                投与した部分が次第に小さくなり、引き伸ばされていた支持組織が元の位置に癒着・固定して、脱出がみられなくなります。<br/>
                                （1週間～1か月）
                            </p>
                        </td>
                        <td>
                            <img src={"/images/zion5-2.gif"}/>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className={"center"}>
                            <img src={"/images/zion5-3.gif"}/>
                        </td>
                    </tr>
                </tbody>
            </table>
            <h1 id={"zion6"}>6.ジオン注の投与後の経過は？</h1>
            <table>
                <thead>
                    <tr><th colSpan={3}>経過（例）</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>当日</td>
                        <td colSpan={2}>
                            <div>
                            麻酔の影響がなくなるまでしばらく安静にします。<br/>
                            歩行開始（ごはんはお粥、ジュースなど）
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>翌日</td>
                        <td colSpan={2}>
                            <div>
                            投与した部分や肛門周囲の状態を診察します。<br/>
                            排便、坐浴、入浴開始（ごはんは普通食）
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>2～5日後</td>
                        <td><div>診察・退院</div></td>
                        <td><div>出血の軽減・痔核の縮小</div></td>
                    </tr>
                    <tr>
                        <td>10日後</td>
                        <td><div>｜</div></td>
                        <td><div>｜</div></td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                        <td><div>｜通院・診察</div></td>
                        <td><div>↓</div></td>
                    </tr>
                    <tr>
                        <td>1か月後</td>
                        <td><div>｜</div></td>
                        <td><div>痔核の退縮</div></td>
                    </tr>
                    <tr>
                        <td>2か月後</td>
                        <td><div>↓</div></td>
                        <td>&nbsp;</td>
                    </tr>
                </tbody>
            </table>
            <table>
                <thead>
                <tr><th colSpan={4}>望ましくない作用（報告例）</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td>当日</td>
                        <td>
                            <div>
                            血圧低下、嘔気（気持ち悪い、胃のあたりがムカムカする）、<br/>
                            頭痛、食欲がないなどの症状がみられることがあります。
                            </div>
                            </td>
                        <td rowSpan={2}>
                            投<br/>
                            与<br/>
                            後<br/>
                            早<br/>
                            い<br/>
                            時<br/>
                        </td>
                        <td rowSpan={3}>
                            投<br/>
                            与<br/>
                            ２<br/>
                            週<br/>
                            間<br/>
                        </td>
                    </tr>
                    <tr>
                        <td>翌日</td>
                        <td>
                            <div>
                            肛門部が重いような感じ（肛門部の違和感）・排便がしにくい<br/>
                             →短期間（数日）でなくなります。<br/>
                            肛門の投与部分（粘膜）が硬くなる<br/>
                             →通常自然に治ります。<br/>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>10日後</td>
                        <td colSpan={2}>
                            <div>
                            発熱は、投与2週間までに一過性にあらわれることがあります。<br/>
                            十分に注意し、発熱した場合にはご相談下さい。
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className={"note"}>
                入院期間及び通院期間は、処置した痔核の数や大きさも含めて患者さんの状態により異なります。
            </div>
            <h2 id={"zion6-1"}>排便はいつから？</h2>
            <ul>
                <li>排便は翌日から可能です。</li>
                <li>痛みをこわがって我慢しないようにしましょう。</li>
            </ul>
            <h2 id={"zion6-2"}>仕事復帰は？</h2>
            <ul>
                <li>数日間はできるだけ安静にしましょう。</li>
                <li>「力仕事」「冷え」「長時間の同じ姿勢」を避けましょう。</li>
            </ul>
            <h1 id={"zion7"}>7.日常生活で注意すべきことはなんでしょうか？</h1>
            <p>
                治療後も以前と同じように肛門に炎症を起こすような生活を続けていると新しい痔ができてしまいます。再び痔にならないためにおしりに負担のかかる生活を改めることが、なによりも大切です。
            </p>
            <table className={"two-column"}>
                <thead>
                    <tr>
                        <td colSpan={2}>
                        規則正しい排便習慣を身につけましょう。
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <img src={"/images/zion7-1.gif"}/>
                            <div>
                                便通を整えるために食物繊維や水分を摂る
                            </div>
                        </td>
                        <td>
                            <img src={"/images/zion7-2.gif"}/>
                            <div>
                                便意があったらトイレに行く<br/>
                                我慢しない
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <img src={"/images/zion7-3.gif"}/>
                            <div>
                                トイレに長居しない いきむのは3分以内<br/>
                                無理に出しきろうとしない<br/>
                            </div>
                        </td>
                        <td>
                            <img src={"/images/zion7-4.gif"}/>
                            <div>
                                下痢などを防ぐためにアルコール類、香辛料などは控える
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <ul>
                <li>
                    腸の働きをよくするために適度な運動をする。
                </li>
                <li>
                    便秘の原因になる無理なダイエットはしない。
                </li>
            </ul>
            <table className={"two-column"}>
                <thead>
                    <tr>
                        <td colSpan={2}>
                            おしりを清潔にしましょう。
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <ul>
                                <li>坐浴を行う<br/>あるいは・・・</li>
                                <li>温水洗浄式便座を使う<br/>
                                    →水圧は弱めに<br/>
                                    →温度に注意<br/>
                                    →刺激し過ぎない
                                </li>
                            </ul>
                        </td>
                        <td>
                            <img src={"/images/zion7-5.gif"}/>
                            <div>
                                おしりに力がかからないように便器の上に洗面器を置いておしりを洗います。
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                            洗った後、おしりをよく乾かす<br/>
                           （乾燥機能がない場合は清潔なタオルなどで軽くおさえるようにします）
                            </div>
                        </td>
                        <td>
                            <img src={"/images/zion7-6.gif"}/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>
                            お風呂に入って血行をよくする
                            </div>
                        </td>
                        <td>
                            <img src={"/images/zion7-7.gif"}/>
                            <div>
                                お風呂に入るときは、石鹸でゴシゴシ洗うのでなく、お湯で流すようにしてください。
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table>
                <thead>
                    <tr>
                        <td>
                            おしりへの負担を減らしましょう。
                        </td>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                        <img src={"/images/zion7-9.gif"}/>
                        <img src={"/images/zion7-8.gif"}/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div>
                        座りっぱなし、立ちっぱなしは肛門がうっ血しやすいので、2時間おきにストレッチ体操などにより血行を改善しましょう。
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <ul>
                <li>
                    長時間、同じ姿勢をとり続けない
                </li>
                <li>
                    過労やストレスを避ける
                </li>
                <li>
                    体を冷やさない
                </li>
            </ul>
            </div>
        </React.Fragment>
    );
}

export default ZionPage;
